import React from "react";
import Login from "./Login";

const LoginWithQuery = props => <Login title={"Login"} {...props} />;

export default LoginWithQuery;
